// API helper for the in-app Report Issue feature.
//
// Server-side handler enriches the issue body with reporter identity
// (name, role, Cognito sub) from the bearer token, then files into the
// upstream GitHub repo using a PAT held in Secrets Manager. The SPA
// only needs to send the title + description plus optional client-side
// diagnostic context — see crates/tres-api/src/handlers/issues.rs.

import { apiFetch } from './api';

export interface ReportContext {
  route?: string;
  user_agent?: string;
  screen?: string;
  graph?: string;
}

export interface ReportRequest {
  title: string;
  description: string;
  context?: ReportContext;
}

export interface ReportResponse {
  issue_url: string;
  issue_number: number;
}

/** POST /api/v1/issues. Returns the new GitHub issue's URL + number on success. */
export function submitIssueReport(body: ReportRequest, accessToken: string) {
  return apiFetch<ReportResponse>('/api/v1/issues', accessToken, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
